interface IconProps {
  className?: string;
}

const iconDefaults = {
  fill: 'none',
  stroke: 'currentColor',
  viewBox: '0 0 24 24',
} as const;

export function SetupIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M12 15.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM19.4 15a1.7 1.7 0 00.34 1.88l.06.06-2.83 2.83-.06-.06a1.7 1.7 0 00-1.88-.34 1.7 1.7 0 00-1.03 1.56V21h-4v-.08A1.7 1.7 0 008.96 19.4a1.7 1.7 0 00-1.88.34l-.06.06-2.83-2.83.06-.06A1.7 1.7 0 004.6 15a1.7 1.7 0 00-1.56-1.03H3v-4h.08A1.7 1.7 0 004.6 8.94a1.7 1.7 0 00-.34-1.88L4.2 7l2.83-2.83.06.06a1.7 1.7 0 001.88.34A1.7 1.7 0 0010 3.01V3h4v.08a1.7 1.7 0 001.03 1.56 1.7 1.7 0 001.88-.34l.06-.06L19.8 7l-.06.06a1.7 1.7 0 00-.34 1.88 1.7 1.7 0 001.56 1.03H21v4h-.08A1.7 1.7 0 0019.4 15z" /></svg>;
}

export function FactoryIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M3 21V10l5 3V10l5 3V10l5 3V4h3v17H3zm4-4h2m3 0h2m3 0h1" /></svg>;
}

export function FirebaseIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M5 19L7.7 4.5a.7.7 0 011.3-.2l2.1 3.9 1.8-5.5a.7.7 0 011.3-.1L19 19l-7 3-7-3zM7.5 17.8L17 9.7" /></svg>;
}

export function PlayStoreIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M5 3.8v16.4a1 1 0 001.55.83l12-8.2a1 1 0 000-1.66l-12-8.2A1 1 0 005 3.8zM6 4l8.5 8L6 20m8.5-8H19" /></svg>;
}

export function PublishIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M12 16V3m0 0L7 8m5-5l5 5M5 14v5a2 2 0 002 2h10a2 2 0 002-2v-5" /></svg>;
}

export function BatchesIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><rect x="3" y="4" width="18" height="6" rx="1.5" strokeWidth={1.7} /><rect x="3" y="14" width="18" height="6" rx="1.5" strokeWidth={1.7} /><path strokeLinecap="round" strokeWidth={1.7} d="M7 7h.01M7 17h.01" /></svg>;
}

export function PulseIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M3 12h4l2-7 4 14 2-7h6" /></svg>;
}

export function PushTestIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 00-4-5.66V5a2 2 0 10-4 0v.34A6 6 0 006 11v3.2a2 2 0 01-.6 1.4L4 17h5m3-5v5m-2-2l2 2 2-2" /></svg>;
}

export function GlobeIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><circle cx="12" cy="12" r="9" strokeWidth={1.7} /><path strokeLinecap="round" strokeWidth={1.7} d="M3 12h18M12 3c2.2 2.45 3.3 5.45 3.3 9S14.2 18.55 12 21c-2.2-2.45-3.3-5.45-3.3-9S9.8 5.45 12 3z" /></svg>;
}

export function CursorIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M5 3l13 9-6 1.5L9 19 5 3zM12 13.5l4 5" /></svg>;
}

export function WebhookIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M7.2 15.5A4 4 0 1110.5 9M16.8 15.5A4 4 0 0113.5 9M9.2 18.5h6.3a4 4 0 001.3-7.8M12 5v4l3-2" /></svg>;
}

export function GameIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M8 8h8a5 5 0 014.8 6.4l-1 3.4a2 2 0 01-3.3.9L14 16h-4l-2.5 2.7a2 2 0 01-3.3-.9l-1-3.4A5 5 0 018 8zM8 11v4m-2-2h4m6-1h.01M18 14h.01" /></svg>;
}

export function LinkIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M10 13a5 5 0 007.1.1l2-2a5 5 0 00-7.1-7.1l-1.1 1.1M14 11a5 5 0 00-7.1-.1l-2 2A5 5 0 0012 20l1.1-1.1" /></svg>;
}

export function InboxIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M4 4h16v14a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm0 10h4l2 3h4l2-3h4" /></svg>;
}

export function MailIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><rect x="3" y="5" width="18" height="14" rx="2" strokeWidth={1.7} /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M4 7l8 6 8-6" /></svg>;
}

export function BugIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M9 7h6a3 3 0 013 3v5a6 6 0 01-12 0v-5a3 3 0 013-3zm0 0V5m6 2V5M6 11H3m3 4H3m15-4h3m-3 4h3M8 3l2 2m6-2l-2 2M12 10v8" /></svg>;
}

export function BookIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d="M4 4.5A2.5 2.5 0 016.5 2H11a1 1 0 011 1v18a3 3 0 00-3-3H4V4.5zm16 0A2.5 2.5 0 0017.5 2H13a1 1 0 00-1 1v18a3 3 0 013-3h5V4.5z" /></svg>;
}

export function FacebookIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor"><path d="M13.7 21v-8h2.7l.4-3.1h-3.1v-2c0-.9.3-1.5 1.6-1.5H17V3.6c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3v2.1H7.5V13h2.8v8h3.4z" /></svg>;
}

export function CalendarIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><rect x="3" y="5" width="18" height="16" rx="2" strokeWidth={1.7} /><path strokeLinecap="round" strokeWidth={1.7} d="M8 3v4m8-4v4M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 17h.01M12 17h.01" /></svg>;
}

export function TemplateIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><rect x="3" y="3" width="18" height="18" rx="2" strokeWidth={1.7} /><path strokeLinecap="round" strokeWidth={1.7} d="M3 9h18M9 9v12" /></svg>;
}

export function RadarIcon({ className = 'w-5 h-5' }: IconProps) {
  return <svg className={className} {...iconDefaults}><circle cx="12" cy="12" r="9" strokeWidth={1.7} /><circle cx="12" cy="12" r="5" strokeWidth={1.7} /><path strokeLinecap="round" strokeWidth={1.7} d="M12 12l6.4-6.4" /><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" /></svg>;
}
